import styled from 'styled-components'

const Wrapper = styled.section`
margin-top: 5%;
`
export default Wrapper
